import React from 'react';
import './CardPhoto.scss';
import './CardPhoto-media.scss';

import { ICardPhoto } from './interfaces';

const CardPhoto = ({ name, position, image }: ICardPhoto) => {
  const gradient = `linear-gradient(180deg, rgba(0, 59, 102, 0) 0%, rgba(0, 59, 102, 0.56) 50%), rgba(0, 59, 102, 0) 100%)`;

  return (
    <div className="card-photo">
      <p className="body1 card-photo__name">{name}</p>
      <p className="body2">{position}</p>
      <div
        className="card-photo__photo"
        style={{ backgroundImage: `url(${image})`, backgroundColor: gradient }}
      ></div>
    </div>
  );
};

export default CardPhoto;
